import { Box, Button } from "@saleor/macaw-ui-next";
import React, { useMemo } from "react";
import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  openOnStorefront: {
    id: "o5VdCW",
    defaultMessage: "Open in Storefront",
    description: "product variant storefront link",
  },
});

interface ProductVariantStorefrontLinkProps {
  urlTemplate: string;
  productSlug: string;
  variantId: string;
}

const ProductVariantStorefrontLink: React.FC<ProductVariantStorefrontLinkProps> = ({
  urlTemplate,
  productSlug,
  variantId,
}) => {
  const intl = useIntl();
  const link = useMemo(
    () =>
      urlTemplate
        .replace("{{productSlug}}", encodeURIComponent(productSlug))
        .replace("{{variantId}}", encodeURIComponent(variantId)),
    [urlTemplate, productSlug, variantId],
  );

  return (
    <Box display="flex" alignItems="center" height="100%" marginLeft={4}>
      <Button target="_blank" as="a" variant="secondary" href={link}>
        {intl.formatMessage(messages.openOnStorefront)}
      </Button>
    </Box>
  );
};

ProductVariantStorefrontLink.displayName = "ProductVariantStorefrontLink";
export default ProductVariantStorefrontLink;
